import React from 'react';
import '../App.css'

function ChatMessage({ role, message }) {
  return (
    <div className={`message ${role}`}>
      {message}
    </div>
  );
}

export default ChatMessage;